import React from "react";
import Button from "../../components/ui/Button";

const BiospecimenHero = () => {
  return (
    <div className="mt-[50px]">
      <section className="relative max-w-[1800px]  py-24 px-6 overflow-hidden flex items-center justify-center min-h-auto bg-white  mx-[20px] xl:m-auto">
        {/* Background Image Layer - Matching the soft abstract look */}
        <div
          className="absolute inset-0 z-0 rounded-[20px] 2xl:rounded-[50px]"
          style={{
            backgroundImage: `url('/images/BiostorageImg/Biostorage.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>

        {/* Content Container */}
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          {/* Title: Using a darker Navy Blue color and specific font weight */}
          <h1 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-extrabold text-[#1a2b6d] leading-tight mb-6 tracking-tight">
            Secure Biospecimen Storage with <br className="hidden md:block" />
            Complete Chain of Custody
          </h1>

          {/* Description: Lighter greyish-blue and centered alignment */}
          <p className=" text-[18px] xl:text-[24px] leading-relaxed mb-10 max-w-[1028px] mx-auto font-medium">
            Protect the integrity of your valuable biospecimens with our
            state-of-the-art storage facility. We maintain strict environmental
            controls, comprehensive monitoring, and detailed documentation to
            ensure your samples remain research-ready for years to come.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            <Button
              className="border-2 border-[#183076] text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[#183076] hover:text-white transition 2xl:text-[24px]"
              text="Book Now"
              to="/rfq"
            />
            <Button
              className="border-2 border-[#183076] text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[#183076] hover:text-white transition 2xl:text-[24px]"
              text="Explore Now"
              to="/biospecimens-services"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BiospecimenHero;
